import { FunctionComponent, memo, useContext } from "react";
import Modal, { ModalContent, ModalHeader, useModal } from "@edgetier/modal";
import { faPencil } from "@fortawesome/pro-solid-svg-icons";
import ExemptionForm from "../exemption-form";

import { IProps } from "./spelling-exemption-edit-action.types";
import { EllipsisMenuContext, EllipsisMenuItem } from "@edgetier/client-components";
import "./spelling-exemption-edit-action.scss";

/**
 * Button component, when clicked, opens the form to edit an exemption in a modal.
 * @param props.exemption   Currently selected exemption
 */
const SpellingExemptionEditAction: FunctionComponent<IProps> = ({ exemption }) => {
    const { lockOpen, unlock } = useContext(EllipsisMenuContext);
    const { openModal, closeModal, modalProps } = useModal({ onCloseModal: unlock });

    return (
        <>
            <Modal {...modalProps}>
                <ModalHeader>
                    <h2>Edit exemption</h2>
                </ModalHeader>
                <ModalContent>
                    <ExemptionForm spellingExemption={exemption} toggleAction={closeModal} />
                </ModalContent>
            </Modal>
            <EllipsisMenuItem
                closeAfterClick={false}
                icon={faPencil}
                onClick={() => {
                    lockOpen();
                    openModal();
                }}
            >
                Edit
            </EllipsisMenuItem>
        </>
    );
};

export default memo(SpellingExemptionEditAction);
